export default __webpack_public_path__ + "static/media/Teachersday2.b1ed8185.JPG";